import { ConstraintFragment, Store_Location_Evaluation_Method } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { StoreChipsOrViewAll } from '../../../components';

const getStoresIds = (
  constraints: ConstraintFragment[],
  evaluationMethod: Store_Location_Evaluation_Method,
) => {
  const cst = getConstraintsByType('ConstraintStoreLocation', constraints);
  return [
    ...new Set(
      cst.flatMap((c) =>
        c.evaluationMethod === evaluationMethod ? c.locations.map((v) => v.id) : [],
      ),
    ),
  ];
};

export const IncludedStoresConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const storeIds = getStoresIds(constraints, Store_Location_Evaluation_Method.Include);

  return <StoreChipsOrViewAll label='Included Stores' description='Stores' ids={storeIds} />;
};

export const ExcludedStoresConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const storeIds = getStoresIds(constraints, Store_Location_Evaluation_Method.Exclude);

  return <StoreChipsOrViewAll label='Excluded Stores' description='Stores' ids={storeIds} />;
};
